import { Company } from '../models/response';

export const matchingCompanyTypesFromServerToClient = (company: Company): Company => ({
  ...company,
  attributes: {
    ...company.attributes,
    internal_users_limit: parseInt((company.attributes?.internal_users_limit ?? '').toString(), 10),
    external_users_limit: parseInt((company.attributes?.external_users_limit ?? '').toString(), 10),
    style: company.attributes?.style,
  },
});

export const matchingCompanyTypesFromClientToServer = (company: Company): Company => ({
  ...company,
  attributes: {
    ...company.attributes,
    style: company.attributes?.style,
  },
});
